import { forwardRef, type TextareaHTMLAttributes } from 'react';

import { cn } from '../../lib/cn';
import {
  CONTROL_CLASSES,
  CONTROL_INVALID_CLASSES,
  Field,
  type FieldOwnProps,
} from '../Field/Field';

/** docs/02-DESIGN-SYSTEM.md §4.1 — same treatment as Input, multi-line. */
export interface TextareaProps
  extends
    FieldOwnProps,
    Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'id' | 'className' | 'required'> {}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { label, hideLabel, hint, error, required, id, className, rows = 6, ...props },
  ref,
) {
  return (
    <Field
      label={label}
      hideLabel={hideLabel}
      hint={hint}
      error={error}
      required={required}
      id={id}
      className={className}
    >
      {(field) => (
        <textarea
          ref={ref}
          rows={rows}
          className={cn(CONTROL_CLASSES, 'resize-y py-3', error && CONTROL_INVALID_CLASSES)}
          {...field}
          {...props}
        />
      )}
    </Field>
  );
});
